import { createAction, props } from '@ngrx/store';
import { SecurityDto } from 'src/app/admin/security-groups/details/models/dto/securityDto';

export enum JobsActionEnum {
    LoadSecurityGroupsSecurity = '[SECURITY GROUPS] Load Security',
    LoadSecurityGroupsSecuritySuccess = '[SECURITY GROUPS] Load Security success',
    LoadSecurityGroupsSecurityFail = '[SECURITY GROUPS] Load Security fail'
}

// Security
export const loadSecurityGroupsSecurity = createAction(
    JobsActionEnum.LoadSecurityGroupsSecurity,
    props<{ jobId: number }>()
);
export const loadSecurityGroupsSecuritySuccess = createAction(
    JobsActionEnum.LoadSecurityGroupsSecuritySuccess,
    props<{ security?: SecurityDto }>()
);
export const loadSecurityGroupsSecurityFail = createAction(
    JobsActionEnum.LoadSecurityGroupsSecurityFail,
    props<{ error: any }>()
);
